import config from '@/utils/ApiUtils'
import { fetchWithToken } from '@/utils/Keycloak'

export default {
  // === Heatmap configs CRUD ===
  getHeatmaps () {
    return fetchWithToken(`${config().favQueryBackend}/heatmap`, { method: 'GET' })
      .then(response => response.json())
  },
  getHeatmapById (heatmapId) {
    return fetchWithToken(`${config().favQueryBackend}/heatmap/${heatmapId}`, { method: 'GET' })
      .then(response => response.json())
  },
  createHeatmap (payload) {
    return fetchWithToken(`${config().favQueryBackend}/heatmap`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(response => {
      if (!response.ok) throw new Error(`Erreur création heatmap: ${response.status}`)
      return response.json()
    })
  },
  updateHeatmap (heatmapId, payload) {
    return fetchWithToken(`${config().favQueryBackend}/heatmap/${heatmapId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(response => response.json())
  },
  deleteHeatmap (heatmapId) {
    return fetchWithToken(`${config().favQueryBackend}/heatmap/${heatmapId}`, { method: 'DELETE' })
      .then(response => response.json())
  },
  addQueryToHeatmap (heatmapId, payload) {
    return fetchWithToken(`${config().favQueryBackend}/heatmap/${heatmapId}/queries`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(response => {
      if (!response.ok) throw new Error(`Erreur ajout query à heatmap: ${response.status}`)
      return response.json()
    })
  },
  removeQueryFromHeatmap (heatmapId, favoriteQueryId) {
    return fetchWithToken(`${config().favQueryBackend}/heatmap/${heatmapId}/queries/${favoriteQueryId}`, {
      method: 'DELETE'
    }).then(response => response.json())
  },
  executeHeatmap (heatmapId, date) {
    const params = date ? `?date=${date}` : ''
    return fetchWithToken(`${config().favQueryBackend}/heatmap/${heatmapId}/execute${params}`, { method: 'GET' })
      .then(response => response.json())
  },
  reorderHeatmaps (orders) {
    return fetchWithToken(`${config().favQueryBackend}/heatmap/reorder`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orders })
    }).then(response => response.json())
  },
  reorderHeatmapQueries (heatmapId, orders) {
    return fetchWithToken(`${config().favQueryBackend}/heatmap/${heatmapId}/queries/reorder`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orders })
    }).then(response => response.json())
  },
  getVersions () {
    return fetchWithToken(`${config().heatmapApi}/versions`, { method: 'GET' })
      .then(response => response.json())
  }
}
